import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

import {InlineMarkdownEditor} from '../../elements/InlineMarkdownEditor';
import {REPORT_FONT_SIZE} from '../constants';
import * as HeadingStyles from './headings.styles';

export const MarkdownBlockWrapper = styled.div`
  ${HeadingStyles.HeadingCollapser}, ${HeadingStyles.DeepLink} {
    padding-top: ${REPORT_FONT_SIZE * 2}px;
  }
  ${HeadingStyles.commonHeadingStyles}
`;
export const MarkdownBlock = styled(InlineMarkdownEditor)<{
  selected?: boolean;
  focused?: boolean;
}>`
  white-space: normal;
  font-family: ${globals.fontName};
  .markdown {
    overflow: auto;
  }
  ${props =>
    !props.readOnly &&
    css`
      font-size: inherit;
      padding: 8px;
      margin: -12px 0 0 -12px;
      border-left: 4px solid transparent;
      border-radius: 4px;

      &:hover {
        background: ${globals.THEME.bgHover};
      }
      textarea {
        font-family: Inconsolata;
        border: none;
        overflow: auto;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        resize: none;
        background: none;
        padding: 2px 0;
        margin: 0;
      }
      &:not(.editing) {
        cursor: pointer;
      }

      &.editing {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-color: ${globals.THEME.border};
      }
    `}
  ${props =>
    props.selected &&
    css`
      &&:not(.editing) {
        background: light-dark(rgb(208, 225, 252), var(--blue-700));
      }
      .placeholder {
        opacity: 0;
      }
    `}
`;

export const EditMarkdownBlockWrapper = styled.div<{converted?: boolean}>`
  border-radius: 4px;
  background-color: ${globals.THEME.bgInverse};
  padding: 8px 12px;
  color: ${globals.THEME.textInverse};
  cursor: pointer;
  &:hover {
    color: ${globals.THEME.textInverse};
  }
  ${props =>
    props.converted &&
    css`
      background: ${globals.THEME.statusSuccessBg};
      color: ${globals.THEME.statusSuccessText};
      cursor: default;
    `}
`;
